<template>
  <div class="dataStatistics">
    <el-row :gutter="24">
      <el-col :span="8">
        <el-card class="box-card">
          <div>单位类别</div>
          <div class="echarts" id="echartsTopLeft"></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div>单位规模</div>
          <div class="echarts" id="echartsTopCenter"></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div>运营时间</div>
          <div class="echarts" id="echartsTopRight"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div>区域统计</div>
          <div class="echarts" id="echartsBottomLeft"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div>行业类别</div>
          <div class="echarts" id="echartsBottomRight"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import * as echarts from "echarts";
export default defineComponent({
  name: "dataStatistics",
  components: {},
  props: {},
  setup(props, context) {
    const state = reactive({
      formVisible: false
    });
    const refData = toRefs(state);
    let myChartTopLeft,
      myChartTopCenter,
      myChartTopRight,
      myChartBottomLeft,
      myChartBottomRight;
    // echarts
    const echartsTopLeft = () => {
      myChartTopLeft = echarts.init(document.getElementById("echartsTopLeft"));
      const optionData = [
        { value: 1, name: "其他" },
        { value: 1, name: "机关团体" },
        { value: 0, name: "事业单位" },
        { value: 0, name: "企业单位" }
      ];
      const option = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          left: "10%",
          top: "center",
          orient: "vertical",
          itemGap: 20,
          width: 300,
          formatter: function(params) {
            switch (params) {
            case "其他":
              return params + "    " + optionData[0].value;
            case "机关团体":
              return params + "    " + optionData[1].value;
            case "事业单位":
              return params + "    " + optionData[2].value;
            case "企业单位":
              return params + " " + optionData[3].value;
            default:
              return "";
            }
          }
        },
        grid: {
          top: 20,
          left: 20
        },
        series: [
          {
            name: "单位类别",
            type: "pie",
            radius: ["50%", "80%"],
            center: ["60%", "53%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: true,
              position: "center",
              fontSize: "20",
              fontWeight: "bold",
              formatter: function(params) {
                let str = 0;
                optionData.forEach(item => {
                  str += Number(item.value);
                });
                return params.seriesName + "\n" + str;
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: optionData
          }
        ]
      };
      myChartTopLeft.setOption(option);
    };
    const echartsTopCenter = () => {
      myChartTopCenter = echarts.init(
        document.getElementById("echartsTopCenter")
      );
      const optionData = [
        { value: 1, name: "未知" },
        { value: 1, name: "微型" },
        { value: 0, name: "小型" },
        { value: 0, name: "中型" },
        { value: 0, name: "大型" }
      ];
      const option = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          left: "center",
          bottom: "0",
          // orient: "vertical",
          // itemGap: 20,
          // width: 300,
          formatter: function(params) {
            switch (params) {
            case "未知":
              return params + "    " + optionData[0].value;
            case "微型":
              return params + "    " + optionData[1].value;
            case "小型":
              return params + "    " + optionData[2].value;
            case "中型":
              return params + " " + optionData[3].value;
            case "大型":
              return params + " " + optionData[4].value;
            default:
              return "";
            }
          }
        },
        series: [
          {
            name: "单位规模",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "36%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: true,
              position: "center",
              fontSize: "20",
              fontWeight: "bold",
              formatter: function(params) {
                let str = 0;
                optionData.forEach(item => {
                  str += Number(item.value);
                });
                return params.seriesName + "\n" + str;
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: optionData
          }
        ]
      };
      myChartTopCenter.setOption(option);
    };
    const echartsTopRight = () => {
      myChartTopRight = echarts.init(
        document.getElementById("echartsTopRight")
      );
      const optionData = [
        { value: 3, name: "未知" },
        { value: 128, name: "一年以下" },
        { value: 154, name: "一至三年" },
        { value: 75, name: "三至五年" },
        { value: 13, name: "五至十年" },
        { value: 13, name: "十年以上" }
      ];
      const option = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          right: "10%",
          top: "center",
          orient: "vertical",
          itemGap: 20,
          width: 300,
          formatter: function(params) {
            switch (params) {
            case "未知":
              return params + "    " + optionData[0].value;
            case "一年以下":
              return params + "    " + optionData[1].value;
            case "一至三年":
              return params + "    " + optionData[2].value;
            case "三至五年":
              return params + " " + optionData[3].value;
            case "五至十年":
              return params + " " + optionData[4].value;
            case "十年以上":
              return params + " " + optionData[5].value;

            default:
              return "";
            }
          }
        },
        grid: {
          top: 20,
          left: 20
        },
        series: [
          {
            name: "运营时间",
            type: "pie",
            radius: ["50%", "80%"],
            center: ["40%", "53%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: true,
              position: "center",
              fontSize: "20",
              fontWeight: "bold",
              formatter: function(params) {
                let str = 0;
                optionData.forEach(item => {
                  str += Number(item.value);
                });
                return params.seriesName + "\n" + str;
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: optionData
          }
        ]
      };
      myChartTopRight.setOption(option);
    };
    const echartsBottomLeft = () => {
      myChartBottomLeft = echarts.init(
        document.getElementById("echartsBottomLeft")
      );
      const option = {
        xAxis: {
          type: "category",
          data: ["汉丰街道"],
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {
          type: "value"
        },
        color: ["#6edfff"],
        series: [
          {
            data: [2],
            type: "bar",
            barMaxWidth: 170,
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: "top", // 在上方显示
                  textStyle: {
                    // 数值样式
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };
      myChartBottomLeft.setOption(option);
    };
    const echartsBottomRight = () => {
      myChartBottomRight = echarts.init(
        document.getElementById("echartsBottomRight")
      );
      const option = {
        tooltip: {
          trigger: "axis",
          borderWidth: 20,
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
          },
          formatter: function(params) {
            console.log(params);
            let str = "";
            params.forEach(item => {
              if (item.value === 0) {
              } else {
                str +=
                  item.marker + item.seriesName + ":" + item.value + "<br>";
              }
            });
            return str;
          }
        },
        legend: {
          left: "center",
          bottom: 40,
          width: 800
        },
        grid: {
          // left: "3%",
          // right: "4%",
          // bottom: "3%",
          // containLabel: true
          top: "20%",
          bottom: "60%"
        },
        xAxis: {
          type: "value",
          show: false
        },
        yAxis: {
          type: "category",
          data: ["Mon"],
          show: false
        },
        series: [
          {
            name: "农、林、牧、渔业",
            barMaxWidth: 60,
            type: "bar",
            stack: "total",
            label: {
              show: true,
              formatter: function(params) {
                if (params.value === 0) {
                  // 为0时不显示
                  return "";
                } else {
                  return params.value;
                }
              }
            },
            emphasis: {
              focus: "series"
            },
            data: [1]
          },
          {
            name: "金融业",
            type: "bar",
            stack: "total",
            label: {
              show: true,
              formatter: function(params) {
                if (params.value === 0) {
                  // 为0时不显示
                  return "";
                } else {
                  return params.value;
                }
              }
            },
            emphasis: {
              focus: "series"
            },
            data: [1]
          }
        ]
      };
      const arrData = [
        { value: 0, name: "未知" },
        { value: 0, name: "采矿业" },
        { value: 0, name: "制造业" },
        { value: 0, name: "电力、燃气及水的生产和供应业" },
        { value: 0, name: "建筑业" },
        { value: 0, name: "交通运输、仓储和邮政业" },
        { value: 0, name: "信息传输、计算机服务和软件业" },
        { value: 0, name: "批发和零售业" },
        { value: 0, name: "住宿和餐饮业" },
        { value: 0, name: "房地产业" },
        { value: 0, name: "租赁和商务服务业" },
        { value: 0, name: "科学研究、技术服务和地质勘查业" },
        { value: 0, name: "水利、环境和公共设施管理业" },
        { value: 0, name: "居民服务和其他服务业" },
        { value: 0, name: "教育" },
        { value: 0, name: "卫生、社会保障和社会福利业" },
        { value: 0, name: "文化、体育和娱乐业" },
        { value: 0, name: "公共管理和社会组织" },
        { value: 0, name: "国际组织" }
      ];
      arrData.forEach(item => {
        option.series.push({
          name: item.name,
          barMaxWidth: 60,
          type: "bar",
          stack: "total",
          label: {
            show: true,
            formatter: function(params) {
              if (params.value === 0) {
                // 为0时不显示
                return "";
              } else {
                return params.value;
              }
            }
          },
          emphasis: {
            focus: "series"
          },
          data: [item.value]
        });
      });
      myChartBottomRight.setOption(option);
    };
    onMounted(() => {
      echartsTopLeft();
      echartsTopCenter();
      echartsTopRight();
      echartsBottomLeft();
      echartsBottomRight();
      window.addEventListener("resize", () => {
        myChartTopLeft.resize();
        myChartTopCenter.resize();
        myChartTopRight.resize();
        myChartBottomLeft.resize();
        myChartBottomRight.resize();
      });
    });
    return {
      ...refData
    };
  }
});
</script>
<style lang="scss" scoped>
.dataStatistics {
  .el-row {
    height: 40%;
    .el-col {
      height: 100%;
      .el-card {
        height: 100%;
        .echarts {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
  .el-row + .el-row {
    height: 58%;
    margin-top: 1%;
  }
}
</style>
